const errorCode = {
  WAITING_APPROVE_SALE_BINDING: 981,
};

export { errorCode };



// WEBPACK FOOTER //
// ./src/config/httpResponse.js